import { useState, useCallback, useRef } from 'react';

export type ToastType = 'default' | 'success' | 'error';

export function useToast() {
  const [msg, setMsg] = useState('');
  const [type, setType] = useState<ToastType>('default');
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const showToast = useCallback((message: string, toastType: ToastType = 'default') => {
    setMsg(message);
    setType(toastType);
    setVisible(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setVisible(false), 3600);
  }, []);

  return { msg, type, visible, showToast };
}
